import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Row, Col, Icon } from "antd";
import { Spring, animated } from "react-spring";
import categoryList from "./categoryList";

const url = "https://d1wumrtbuo797i.cloudfront.net/";

class Categories extends Component {
  state = {
    hover: -1,
  };

  handleMouseEnter = index => {
    this.setState({
      hover: index,
    });
  };

  renderImages() {
    const { hover } = this.state;

    return (
      <Row type="flex" justify="space-between">
        {categoryList.map(([index, { category, thumb, id, children, count, child }]) => {
          if (child) return null;

          let link = `/textures/${category}/${id}`;
          if (children) {
            link = `/category/${category}/${id}`;
          }
          return (
            <Col
              style={{ textAlign: "center" }}
              key={category}
              xs={12}
              md={6}
              lg={6}
              xl={4}
              xxl={2}
            >
              <Link to={link}>
                <Spring
                  from={{}}
                  to={{
                    scale: hover === id ? 0.9 : 1,
                    color: hover === id ? "#fff" : "#a9a9a9",
                  }}
                  toggle={hover} // Additional props will be spread over the child
                >
                  {({ scale, color }) => (
                    <div>
                      <animated.div
                        onMouseEnter={() => this.handleMouseEnter(id)}
                        onMouseLeave={() => this.setState({ hover: -1 })}
                        style={{
                          transform: `scale3d(${scale}, ${scale}, ${scale})`,
                          marginBottom: "3%",
                        }}
                      >
                        <img
                          alt={thumb}
                          style={{
                            width: "90%",
                            height: "90%",
                          }}
                          src={url + thumb}
                        />
                        <span
                          style={{
                            color,
                            fontSize: "1.1em",
                          }}
                        >
                          <Icon
                            className="hvr-grow"
                            style={{ marginRight: "0.5em" }}
                            type="folder"
                            theme="filled"
                          />
                          {category}
                          <span style={{ fontSize: "1em", color: "grey" }}>
                            {` (${count || 0})`}
                          </span>
                        </span>
                      </animated.div>
                    </div>
                  )}
                </Spring>
              </Link>
            </Col>
          );
        })}
      </Row>
    );
  }

  render() {
    return <div style={{ margin: "1.5em" }}>{this.renderImages()}</div>;
  }
}
export default withRouter(Categories);



// WEBPACK FOOTER //
// ./src/components/Categories.js